<template>
  <div>
    <div class="bk" style="background-image: url('/img/webbg.png');" >
      <div class="content"> <!-- v-if="!isMobile" -->
          <div class="header" style="display: flex;flex-direction: column;">
            <div class="title">
              成都七中东部学校AI数智人</div>  
            <div class="account-div" >
                <img src="../assets/img/login/szr_ic01@2x.png" class="account-img">
                
                <input class="account-input"  v-model="userName"  placeholder="请输入账号" />
            </div>
            <div class="pwd-div" >
              <img src="../assets/img/login/szr_ic02@2x.png"  class="pwd-img" >
               <input type="password"  class="pwd-input"  v-model="password"  placeholder="请输入密码"    @keydown.enter="login" />
            </div>

            <div>
              <button  class="login-button"   @click="login">登录</button>
            </div>
          </div>
      </div>
      <!-- <div class="mf-content" >
        <div class="header" style="display: flex;flex-direction: column;">
            <div style="font-size: 1rem;padding-top: 15vh;">成都七中东部学校AI数智人</div>  
      
            <div style="height: 10vw;background-color: #FFFFFF;border-radius: 0.2vw;width: 80vw;margin: 0 auto;margin-top: 14vh;">
                
                <img src="../assets/img/login/szr_ic01@2x.png" style="width: 6vw;margin-top: 2vw;border: 1px dashed #ABABAB;">
                
                <input   v-model="userName" style="border: none;outline: none;height:  6vw;width: 70vw;float: right; font-size: 0.9rem;
                color: #ABABAB;margin-top: 2vw;"  placeholder="请输入账号" />
            </div>
            <div style="height: 10vw;background-color: #FFFFFF;border-radius: 2px;width: 80vw;margin: 0 auto;margin-top: 2vh;">
              <img src="../assets/img/login/szr_ic02@2x.png" style="width: 6vw;margin-top: 2vw;border: 1px dashed #ABABAB;">
     
               <input type="password"   style="border: none;outline: none;height:  6vw;width: 70vw;float: right; font-size: 0.9rem;
                color: #ABABAB;margin-top: 2vw;" v-model="password"      placeholder="请输入密码" />
            </div>

            <div>
              <button style="width: 80vw;margin-top: 5vh;height: 10vw;background-color:#31A7EA ;border-radius: 0.5vw;border: none;
              color: #FFFFFF;font-weight:500;font-size: 1rem;"   @click="login">登录</button>
            </div>
          </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      userName: "",
      password: "",
    };
  },
  mounted() {
    let errorInfo =  localStorage.getItem("ERROR_INFO")
    console.log("ERROR_INFOERROR_INFOERROR_INFO",errorInfo)
    if(errorInfo){
      this.$message.error('token已失效请重新登陆');

      localStorage.removeItem("ERROR_INFO")
    }

  },
  methods: {
    login() {

      if(!this.userName){
        this.$message({
          message: '请输入账户',
          type: 'warning'
        });
        return
      }
      if(!this.password){
        this.$message({
          message: '请输入密码',
          type: 'warning'
        });
        return
      }

        let loginInfo = {
            account: this.userName,
            password:this.password,
            grantType:"username"
        }
        this.$axios.post(this.$urls.loginUrl,loginInfo).then((res)=>{
        console.log("resres",res)
          if(res.code==0){
            res.data.type = "H5_SAY"
            localStorage.setItem("USER_INFO",JSON.stringify(res.data))
            this.$router.push('/choice'); // 跳转到名为'dashboard'的路由页面
          }else{
            this.$message({
                 message:res.msg,
                  type: 'warning'
                });

          }

      })
    },
  },
};
</script>
<style scoped>
@media screen and  (max-width:768px ) {

  
.account-div{
  height: 7vh;background-color: #FFFFFF;border-radius: 2vw;width: 90%;margin: 0 auto;margin-top: 10vh;
} 
.account-input{
  border: none;outline: none;height: 5vh;width:75%;float: right; font-size: 1rem;margin-right: 2%;
  color: #ABABAB;margin-top: 1vh;
}  
.account-img{
  width: 4.2vh;margin-top: 1.2vh;border: 1px dashed #ABABAB;
}
.pwd-div{
  height: 7vh;background-color: #FFFFFF;border-radius: 2vw;width: 90%;margin: 0 auto;margin-top: 2vh;
} 

.pwd-img{
  width: 4.2vh;margin-top: 1.2vh;border: 1px dashed #ABABAB;
} 

.pwd-input{
  border: none;outline: none;height: 5vh;width:75%;float: right; font-size: 1rem;margin-right: 2%;
  color: #ABABAB;margin-top: 1vh;
}   

.login-button{
  width:90%;margin-top: 2vw;height: 7vh;background-color:#31A7EA ;border-radius: 2vw;border: none;
  color: #FFFFFF;font-weight:500;font-size: 1.1rem;
} 



}





@media screen and  (min-width:768px ) {
  .account-div{
  height: 5vh;background-color: #FFFFFF;border-radius: 0.2vw;width: 20vw;margin: 0 auto;margin-top: 10vh;
} 

  .account-input{
  border: none;outline: none;height: 3vh;width: 17vw;float: right; font-size: 0.8vw;
  color: #ABABAB;margin-top: 1vh;
}  
.account-img{
width: 1.5vw;margin-top: 1.2vh;border: 1px dashed #ABABAB;
}

.pwd-div{
  height: 5vh;background-color: #FFFFFF;border-radius: 2px;width: 20vw;margin: 0 auto;margin-top: 2vh;
} 
.pwd-img{
  width: 1.5vw;margin-top: 1.2vh;border: 1px dashed #ABABAB;
} 
.pwd-input{
  border: none;outline: none;height: 3vh;width: 17vw;float: right; font-size: 0.8vw;
  color: #ABABAB;margin-top: 1vh;
} 
.login-button{
  width: 20vw;margin-top: 2vw;height: 5vh;background-color:#31A7EA ;border-radius: 0.5vw;border: none;
  color: #FFFFFF;font-weight:500;font-size: 1.1vw;
} 


}



input::placeholder {
  color: #ABABAB; /* 设置占位符文本的颜色为灰色 */
}
.bk{
     width: 100vw;
        height: 100vh;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
}

.content{
  width: 80vw;
  height: 50vh;
  color: #FFFFFF;
  font-size: 0.8vw;
  font-family: Arial, Helvetica, sans-serif;
  margin: 0 auto;
}

.mf-content{
  width: 100%;
  height: 100%;
  color: #FFFFFF;
  font-size: 0.8vw;
  font-family: Arial, Helvetica, sans-serif;
  margin: 0 auto;
}

.header{
  position: relative;
}
.title{

    font-size: 1rem;
}
.login{
  padding: 2vw;
}
bottom:hover{
  background-color: #2878ff;
}
</style>